import { PRODUCTION_TABS, SORT_ORDERS, SORT_TYPES } from '@ProdWb/constants'
import { TAG_COLORS } from '@OpsWb/constants'

import { JobBoardStatus } from '~/gql/graphql'

export const JOB_LIST_PLACEMENT = 'job-list-page'

export const JOB_FILTERS = {
    JOB_TRACK_STATUS: `${PRODUCTION_TABS.jobs}_trackStatus`,
    MILESTONE: `${PRODUCTION_TABS.jobs}_milestone`,
    COMMITTED_DOCK_DATE: `${PRODUCTION_TABS.jobs}_committedDockDate`,
    COMMITTED_COMPLETION_DATE: `${PRODUCTION_TABS.jobs}_committedCompletionDate`,
    MP_NAME: `${PRODUCTION_TABS.jobs}_mpName`,
    JOB_STATUS: `${PRODUCTION_TABS.jobs}_jobStatus`,
    QUEUE_STATUS: `${PRODUCTION_TABS.jobs}_queueStatus`,
    JOB_BOARD_STATUS: `${PRODUCTION_TABS.jobs}_jobBoardStatus`,
    JOB_BOARD_DATE: `${PRODUCTION_TABS.jobs}_jobBoardDate`,
    JOB_BOARD_REGION: `${PRODUCTION_TABS.jobs}_jobBoardRegion`,
    LEAD_TIME: `${PRODUCTION_TABS.jobs}_leadTime`,
    PAYOUT: `${PRODUCTION_TABS.jobs}_payout`,
    PRIORITY: `${PRODUCTION_TABS.jobs}_priority`,
    COUNTRYCODE: `${PRODUCTION_TABS.jobs}_countrycode`,
    REGION: `${PRODUCTION_TABS.jobs}_region`,
    ORDER_TYPE: `${PRODUCTION_TABS.jobs}_orderType`,
    PROCESS: `${PRODUCTION_TABS.jobs}_process`,
    PROCESS_TYPE: `${PRODUCTION_TABS.jobs}_processType`,
    MP_MFG_DRI: `${PRODUCTION_TABS.jobs}_mpMfgDri`,
    CUSTOMER_MFG_DRI: `${PRODUCTION_TABS.jobs}_customerMfgDri`,
    SORT: `${PRODUCTION_TABS.jobs}_sort`,
    SALES_ORDER: `${PRODUCTION_TABS.jobs}_salesOrder`,
    PROJECT: `${PRODUCTION_TABS.jobs}_project`,
    JOB_NAME: `${PRODUCTION_TABS.jobs}_jobName`,
    SALE_ORDER_NAME_EXACT: `${PRODUCTION_TABS.jobs}_salesOrderName`,
    CUSTOMER_COMPANY: `${PRODUCTION_TABS.jobs}_customerCompany`,
    CUSTOMER_NAME: `${PRODUCTION_TABS.jobs}_customerName`,
    BUSINESS_UNIT: `${PRODUCTION_TABS.jobs}_businessUnit`,
}

export const JOB_RANGE_FILTER = [
    `${PRODUCTION_TABS.jobs}_payout`,
    `${PRODUCTION_TABS.jobs}_leadTime`,
    `${PRODUCTION_TABS.jobs}_jobBoardDate`,
    `${PRODUCTION_TABS.jobs}_committedDockDate`,
    `${PRODUCTION_TABS.jobs}_committedCompletionDate`,
]

export const JOBS_FILTER_KEY_MAPPING = {
    [JOB_FILTERS.JOB_TRACK_STATUS]: 'trackStatus',
    [JOB_FILTERS.MILESTONE]: 'nextMilestone',
    [`${PRODUCTION_TABS.jobs}_committedDockDateStart`]:
        'committedProductionStartDate',
    [`${PRODUCTION_TABS.jobs}_committedDockDateEnd`]:
        'committedProductionEndDate',
    [`${PRODUCTION_TABS.jobs}_committedCompletionDateStart`]:
        'committedCompletionStartDate',
    [`${PRODUCTION_TABS.jobs}_committedCompletionDateEnd`]:
        'committedCompletionEndDate',
    [JOB_FILTERS.MP_NAME]: 'mfgPartnerIds',
    [JOB_FILTERS.JOB_STATUS]: 'jobComputedStatus',
    [JOB_FILTERS.QUEUE_STATUS]: 'queueStatus',
    [JOB_FILTERS.JOB_BOARD_STATUS]: 'jobBoardStatus',
    [`${PRODUCTION_TABS.jobs}_jobBoardDateStart`]: 'jobBoardStartDate',
    [`${PRODUCTION_TABS.jobs}_jobBoardDateEnd`]: 'jobBoardEndDate',
    [JOB_FILTERS.JOB_BOARD_REGION]: 'jobBoardRegionIds',
    [`${PRODUCTION_TABS.jobs}_leadTimeStart`]: 'leadTimeMin',
    [`${PRODUCTION_TABS.jobs}_leadTimeEnd`]: 'leadTimeMax',
    [`${PRODUCTION_TABS.jobs}_payoutStart`]: 'payoutMin',
    [`${PRODUCTION_TABS.jobs}_payoutEnd`]: 'payoutMax',
    [JOB_FILTERS.PRIORITY]: 'priority',
    [JOB_FILTERS.COUNTRYCODE]: 'productionCountry',
    [JOB_FILTERS.REGION]: 'manufacturingRegion',
    [JOB_FILTERS.ORDER_TYPE]: 'orderType',
    [JOB_FILTERS.PROCESS]: 'processIds',
    [JOB_FILTERS.PROCESS_TYPE]: 'processTypeIds',
    [JOB_FILTERS.MP_MFG_DRI]: 'mpMfgDriIds',
    [JOB_FILTERS.CUSTOMER_MFG_DRI]: 'customerMfgDriIds',
    [JOB_FILTERS.SALES_ORDER]: 'salesOrderName',
    [JOB_FILTERS.SALE_ORDER_NAME_EXACT]: 'exactMatchSalesOrderName',
    [JOB_FILTERS.PROJECT]: 'projectName',
    [JOB_FILTERS.JOB_NAME]: 'jobName',
    [JOB_FILTERS.PROJECT]: 'projectName',
    [JOB_FILTERS.SORT]: 'sort',
    [JOB_FILTERS.CUSTOMER_COMPANY]: 'customerCompanyName',
    [JOB_FILTERS.CUSTOMER_NAME]: 'customerName',
    [JOB_FILTERS.BUSINESS_UNIT]: 'businessUnits',
} as const

export const JOBS_DRAWER_TITLE = 'Filter jobs'

export const JOBS_SORT_OPTIONS = [
    {
        label: 'Payout',
        name: SORT_TYPES.jobPayout,
        display: 'Payout',
        ascending: '$',
        descending: '$',
        order: SORT_ORDERS.ascending,
        applied: false,
    },
    {
        label: 'Job due date',
        name: SORT_TYPES.jobDueDate,
        display: 'Job due',
        ascending: 'Newest',
        descending: 'Oldest',
        order: SORT_ORDERS.ascending,
        applied: false,
    },
    {
        label: 'Priority',
        name: SORT_TYPES.priority,
        display: 'Priority',
        ascending: 'High',
        descending: 'Low',
        order: SORT_ORDERS.ascending,
        applied: false,
    },
    {
        label: 'Leadtime',
        name: SORT_TYPES.leadTime,
        display: 'Leadtime',
        ascending: 'Longest',
        descending: 'Shortest',
        order: SORT_ORDERS.ascending,
        applied: false,
    },
]

export const QUEUE_STATUS_FILTERS = [
    { label: 'In progress', value: 'in_progress' },
    { label: 'Empty', value: 'empty' },
    { label: 'Paused', value: 'paused' },
    { label: 'Ended', value: 'ended' },
    { label: 'Accepted', value: 'accepted' },
    { label: 'Cancelled', value: 'canceled' },
]

export const JOB_BOARD_STATUS_FILTERS = [
    { label: 'In job board', value: JobBoardStatus.in_progress },
    { label: 'Pending job board', value: JobBoardStatus.not_started },
    { label: 'Job board accepted', value: JobBoardStatus.completed },
    { label: 'Job board ended', value: JobBoardStatus.ended },
]

export const JOB_STATUS_FILTERS: { label: string; value: string }[] = [
    { label: 'Unaccepted', value: 'unaccepted' },
    { label: 'In primary processing', value: 'in_primary_processing' },
    { label: 'In secondary processing', value: 'in_secondary_processing' },
    { label: 'In inspection', value: 'in_inspection' },
    { label: 'Inspection submitted', value: 'inspection_submitted' },
    { label: 'Completed', value: 'completed' },
    { label: 'Cancelled', value: 'canceled' },
]

export const JOB_TRACK_STATUS_FILTER = [
    { label: 'On track', value: 'on_track' },
    { label: 'Off track', value: 'off_track' },
]

export const REGION_FILTERS = [
    { label: 'Domestic', value: 'domestic' },
    { label: 'Overseas', value: 'overseas' },
    { label: 'Multiple', value: 'multiple' },
]

export const PRIORITY_FILTER_TYPES = {
    VERY_URGENT: 'Very Urgent',
    URGENT: 'Urgent',
    NORMAL: 'Normal',
    NOT_URGENT: 'Not Urgent',
}

export const PRIORITY_FILTERS = [
    {
        label: PRIORITY_FILTER_TYPES.VERY_URGENT,
        value: PRIORITY_FILTER_TYPES.VERY_URGENT,
    },
    {
        label: PRIORITY_FILTER_TYPES.URGENT,
        value: PRIORITY_FILTER_TYPES.URGENT,
    },
    {
        label: PRIORITY_FILTER_TYPES.NORMAL,
        value: PRIORITY_FILTER_TYPES.NORMAL,
    },
    {
        label: PRIORITY_FILTER_TYPES.NOT_URGENT,
        value: PRIORITY_FILTER_TYPES.NOT_URGENT,
    },
]

export const MILESTONE_LIST = {
    scheduling: 'scheduling',
    production: 'production',
    inspection: 'inspection',
    delivery_order: 'delivery_order',
    shipping: 'shipping',
    customer_delivery: 'customer_delivery',
}

export const COMMITTED_DATE_KEY_MAPPING = {
    [MILESTONE_LIST.scheduling]: 'committedSchedulingDate',
    [MILESTONE_LIST.production]: 'committedProductionDate',
    [MILESTONE_LIST.inspection]: 'committedInspectionDate',
    [MILESTONE_LIST.delivery_order]: 'committedDeliveryOrderDate',
    [MILESTONE_LIST.shipping]: 'committedShippingDate',
    [MILESTONE_LIST.customer_delivery]: 'committedCustomerDeliveryDate',
}

export const POR_DATE_KEY_MAPPING = {
    [MILESTONE_LIST.scheduling]: 'porSchedulingDate',
    [MILESTONE_LIST.production]: 'porProductionDate',
    [MILESTONE_LIST.inspection]: 'porInspectionDate',
    [MILESTONE_LIST.delivery_order]: 'porDeliveryOrderDate',
    [MILESTONE_LIST.shipping]: 'porShippingDate',
    [MILESTONE_LIST.customer_delivery]: 'porCustomerDeliveryDate',
}

export const ACTUAL_DATE_KEY_MAPPING = {
    [MILESTONE_LIST.scheduling]: 'actualSchedulingDate',
    [MILESTONE_LIST.production]: 'actualProductionDate',
    [MILESTONE_LIST.inspection]: 'actualInspectionDate',
    [MILESTONE_LIST.delivery_order]: 'actualDeliveryOrderDate',
    [MILESTONE_LIST.shipping]: 'actualShippingDate',
    [MILESTONE_LIST.customer_delivery]: 'actualCustomerDeliveryDate',
}

export const JOB_BOARD_TITLES = {
    in_progress: 'In job board',
    not_started: 'Pending job board',
    accepted: 'Job board accepted',
    ended: 'Job board ended',
}

export const QUEUE_STATUS = Object.freeze({
    empty: 'Empty',
    paused: 'Paused',
    in_progress: 'In progress',
    accepted: 'Accepted',
    ended: 'Ended',
    canceled: 'Cancelled',
})

export const JOB_BOARD_STATUS = {
    completed: 'completed',
    in_progress: 'in_progress',
    not_started: 'not_started',
    ended: 'ended',
}

export const QUEUE_STATUS_COLOR = Object.freeze({
    [QUEUE_STATUS.empty]: TAG_COLORS.ORANGE,
    [QUEUE_STATUS.paused]: TAG_COLORS.ORANGE,
    [QUEUE_STATUS.in_progress]: TAG_COLORS.BLUE,
    [QUEUE_STATUS.accepted]: TAG_COLORS.GREEN,
    [QUEUE_STATUS.ended]: TAG_COLORS.ORANGE,
    [QUEUE_STATUS.canceled]: '',
})

export const JOB_BOARD_STATUS_COLOR = Object.freeze({
    [JOB_BOARD_STATUS.completed]: TAG_COLORS.GREEN,
    [JOB_BOARD_STATUS.in_progress]: TAG_COLORS.BLUE,
    [JOB_BOARD_STATUS.not_started]: undefined,
    [JOB_BOARD_STATUS.ended]: TAG_COLORS.ORANGE,
})

export const JOB_LIST_APPILIED_FILTER_LIST = {
    [JOB_FILTERS.JOB_TRACK_STATUS]: 'Track status',
    [JOB_FILTERS.MILESTONE]: 'Current milestone',
    [JOB_FILTERS.COMMITTED_DOCK_DATE]: 'Committed dock date is',
    [JOB_FILTERS.COMMITTED_COMPLETION_DATE]:
        'Committed shipment release date is',
    [JOB_FILTERS.MP_NAME]: 'MP name',
    [JOB_FILTERS.PAYOUT]: 'Payout',
    [JOB_FILTERS.JOB_STATUS]: 'Job status',
    [JOB_FILTERS.QUEUE_STATUS]: 'Queue status',
    [JOB_FILTERS.JOB_BOARD_STATUS]: 'Job board status',
    [JOB_FILTERS.JOB_BOARD_DATE]: 'Job board date',
    [JOB_FILTERS.JOB_BOARD_REGION]: 'Job board region',
    [JOB_FILTERS.LEAD_TIME]: 'Production days',
    [JOB_FILTERS.PRIORITY]: 'Priority',
    [JOB_FILTERS.REGION]: 'Region',
    [JOB_FILTERS.COUNTRYCODE]: 'Production country',
    [JOB_FILTERS.ORDER_TYPE]: 'Order type',
    [JOB_FILTERS.PROCESS]: 'Process',
    [JOB_FILTERS.PROCESS_TYPE]: 'Process type',
    [JOB_FILTERS.MP_MFG_DRI]: 'MP Mfg DRI',
    [JOB_FILTERS.CUSTOMER_MFG_DRI]: 'Customer Mfg DRI',
    [JOB_FILTERS.JOB_NAME]: 'Job name',
    [JOB_FILTERS.SALES_ORDER]: 'Sales order',
    [JOB_FILTERS.SALE_ORDER_NAME_EXACT]: 'Sales order',
    [JOB_FILTERS.PROJECT]: 'Project',
    [JOB_FILTERS.SORT]: 'Sort By',
    [JOB_FILTERS.CUSTOMER_COMPANY]: 'Customer company',
    [JOB_FILTERS.CUSTOMER_NAME]: 'Customer name',
    [JOB_FILTERS.BUSINESS_UNIT]: 'Business unit',
}
